import { Block, FurnitureListing } from '@shared/models';

export const listingMeublesImageNomDescriptionMock = (productType: string): Block<FurnitureListing> => ({
  type: 'listing-meubles-image-nom-description',
  data: {
    productType,
    iconText: {
      icon: {
        svg: '/assets/tmp/store.svg',
      },
      text: 'Tous nos meubles et mécanismes sont garantis 10 ans',
    },
    infoText: `Le nombre d'étagères varie en fonction de la hauteur du meuble.`,
  },
});
